import Vue from 'vue'

export default {
  bus: new Vue(),

  Logout: 'logout',
  Alert: 'alert'
}
